"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentElement = exports.parseIntoRichContent = void 0;
const react_1 = __importDefault(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const rich_content_fragment_1 = require("../rich-content-fragment");
const rich_content_heading_1 = require("../rich-content-heading");
const rich_content_link_1 = require("../rich-content-link");
const rich_content_list_1 = require("../rich-content-list");
const rich_content_media_1 = require("../rich-content-media");
const rich_content_money_1 = require("../rich-content-money");
const rich_content_paragraph_1 = require("../rich-content-paragraph");
const rich_content_semantic_1 = require("../rich-content-semantic");
const rich_content_text_1 = require("../rich-content-text");
const types_1 = require("../types");
const isRichContent = (object) => {
    if (!object || typeof object !== 'object') {
        return false;
    }
    return !!Object.keys(object).find((objectKey) => types_1.richContentKeys.find((richContentKey) => richContentKey === objectKey));
};
const parseIntoRichContent = (input) => {
    try {
        const parsedResult = JSON.parse(input);
        return parsedResult;
    }
    catch (err) {
        monera_app_core_1.LOGGER.error(`Unable to parse the following input into RichContent: ${JSON.stringify(input)}`, err);
        return null;
    }
};
exports.parseIntoRichContent = parseIntoRichContent;
const RichContentElement = ({ children, path = 'root', bold, italic, color, fontSize }) => {
    const richContentChildren = isRichContent(children) ? children : (0, exports.parseIntoRichContent)(children);
    if (!richContentChildren) {
        return null;
    }
    const key = Object.keys(richContentChildren)[0];
    if (!types_1.RichContentAttributes[key]) {
        return null;
    }
    switch (key) {
        case types_1.RichContentAttributes.semanticContent:
            return react_1.default.createElement(rich_content_semantic_1.RichContentSemantic, { path: `${path}.${key}` }, richContentChildren[key]);
        case types_1.RichContentAttributes.list:
            return (react_1.default.createElement(rich_content_list_1.RichContentList, { bold: bold, italic: italic, path: `${path}.${key}`, color: color, fontSize: fontSize }, richContentChildren[key]));
        case types_1.RichContentAttributes.fragments:
            return (react_1.default.createElement(rich_content_fragment_1.RichContentFragment, { bold: bold, italic: italic, path: `${path}.${key}`, color: color, fontSize: fontSize }, richContentChildren[key]));
        case types_1.RichContentAttributes.paragraph:
            return (react_1.default.createElement(rich_content_paragraph_1.RichContentParagraph, { bold: bold, italic: italic, path: `${path}.${key}`, color: color, fontSize: fontSize }, richContentChildren[key]));
        case types_1.RichContentAttributes.headingContent:
            return react_1.default.createElement(rich_content_heading_1.RichContentHeading, { color: color }, richContentChildren[key]);
        case types_1.RichContentAttributes.text:
            return (react_1.default.createElement(rich_content_text_1.RichContentText, { bold: bold, italic: italic, color: color, fontSize: fontSize }, richContentChildren[key]));
        case types_1.RichContentAttributes.media:
            return react_1.default.createElement(rich_content_media_1.RichContentMedia, null, richContentChildren[key]);
        case types_1.RichContentAttributes.link:
            return (react_1.default.createElement(rich_content_link_1.RichContentLink, { path: `${path}.${key}`, fontSize: fontSize }, richContentChildren[key]));
        case types_1.RichContentAttributes.money:
            return react_1.default.createElement(rich_content_money_1.RichContentMoney, { money: richContentChildren[key], fontSize: fontSize });
        case types_1.RichContentAttributes.dateTime:
        case types_1.RichContentAttributes.inlinePopover:
        case types_1.RichContentAttributes.popover:
        default:
            return null;
    }
};
exports.RichContentElement = RichContentElement;
